import React from 'react';

export type RenderChildProps<T> = Omit<T, 'as' | 'render' | 'children'>;

export interface RenderFunction<T> {
  (props: T): React.ReactNode;
}

export type RenderProps<T> = {
  as?: React.ElementType;
  // FIXME: react/no-unused-prop-types 规则当前不能正确识别 `render` 被其他函数所使用，此处暂时禁用
  // eslint-disable-next-line react/no-unused-prop-types
  render?: RenderFunction<RenderChildProps<RenderProps<T>>>;
  // FIXME: react/no-unused-prop-types 规则当前不能正确识别 `children` 被其他函数所使用，此处暂时禁用
  // eslint-disable-next-line react/no-unused-prop-types
  children?: RenderFunction<RenderChildProps<RenderProps<T>>> | React.ReactNode;
} & RenderChildProps<T>;

export function render<T>(props: RenderProps<T>): React.ReactNode {
  const { as: Component, render, children, ...ownProps } = props;

  if (Component) {
    return <Component {...ownProps}>{children}</Component>;
  }

  if (render) {
    return render(ownProps);
  }

  if (typeof children === 'function') {
    return children(ownProps);
  }

  return children;
}

export function Render<T = Record<string, any>>(props: RenderProps<T>) {
  const { as: Component } = props;

  if (Component) {
    return render(props) as React.ReactElement;
  }

  return <>{render(props)}</>;
}
